import { createContext, useContext, useEffect, useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import { useLocation, useNavigate } from "react-router-dom";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchuser: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setUser(data.user);
      } else {
        const publicRoutes = ["/", "", "/about", "/whyus", "/faq", "/crypto", "/forex", "/stocks", "/legal", "/policy", "/terms", "/login", "/register", "/forgot-password", "/reset-password", "/testpage"];
        const currentPath = location.pathname.replace("/dash", "") || "/";
        if (!publicRoutes.includes(currentPath)) {
          navigate("/login");
        }
      }
    })
    .catch(err => {
      const publicRoutes = ["/", "", "/about", "/whyus", "/faq", "/crypto", "/forex", "/stocks", "/legal", "/policy", "/terms", "/login", "/register", "/forgot-password", "/reset-password", "/testpage"];
      const currentPath = location.pathname.replace("/dash", "") || "/";
      if (!publicRoutes.includes(currentPath)) {
        navigate("/login");
      }
    })
    .finally(() => setLoading(false));
  }, [navigate, location]); 

  if (loading) {
    return <div style={{ textAlign: "center", marginTop: "20%" }}><FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '30px', color: '#31acee', opacity: '0.5'}} spin /></div>;
  }

  return (
    <UserContext.Provider value={{ user, setUser }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);